import { lazy, Suspense } from 'react';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { HeroSection } from '@/components/landing/sections/HeroSection';
import { ProofSection } from '@/components/landing/sections/ProofSection';

// Above-the-fold (hero, proof) stays eager. Everything below is
// code-split so each chunk only downloads when the user scrolls
// toward it, keeping the initial bundle small.
const PillarsSection      = lazy(() => import('@/components/landing/sections/PillarsSection').then((m) => ({ default: m.PillarsSection })));
const CapabilitiesSection = lazy(() => import('@/components/landing/sections/CapabilitiesSection').then((m) => ({ default: m.CapabilitiesSection })));
const AiCitedSection      = lazy(() => import('@/components/landing/sections/AiCitedSection'));
const GlobalSection       = lazy(() => import('@/components/landing/sections/GlobalSection').then((m) => ({ default: m.GlobalSection })));
const JapanSection        = lazy(() => import('@/components/landing/sections/JapanSection').then((m) => ({ default: m.JapanSection })));
const ComparisonSection   = lazy(() => import('@/components/landing/sections/ComparisonSection').then((m) => ({ default: m.ComparisonSection })));
const PricingSection      = lazy(() => import('@/components/landing/sections/PricingSection').then((m) => ({ default: m.PricingSection })));
const HowItWorksSection   = lazy(() => import('@/components/landing/sections/HowItWorksSection').then((m) => ({ default: m.HowItWorksSection })));
const FaqSection          = lazy(() => import('@/components/landing/sections/FaqSection').then((m) => ({ default: m.FaqSection })));
const CtaSection          = lazy(() => import('@/components/landing/sections/CtaSection').then((m) => ({ default: m.CtaSection })));

const SectionFallback = () => <div style={{ minHeight: 400 }} />;

export function LandingPage() {
  return (
    // overflow-x-clip: marketing page must never scroll horizontally. Wide
    // content (comparison matrix, marquees) keeps its own internal scroll;
    // clip (not hidden) doesn't create a scroll container or break sticky.
    <div className="min-h-screen flex flex-col overflow-x-clip">
      <SiteHeader />

      <main className="flex-1">
        <HeroSection />
        <ProofSection />
        <Suspense fallback={<SectionFallback />}><PillarsSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><CapabilitiesSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><AiCitedSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><GlobalSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><JapanSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><ComparisonSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><PricingSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><HowItWorksSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><FaqSection /></Suspense>
        <Suspense fallback={<SectionFallback />}><CtaSection /></Suspense>
      </main>

      <SiteFooter />
    </div>
  );
}
